import { api } from "./api";
import { getToken } from "./admin";

function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

// Public reads
export async function fetchPublic(resource) {
  const { data } = await api.get(`/content/${resource}`);
  return data;
}

// Admin CRUD
export async function adminList(resource) {
  const { data } = await api.get(`/admin/${resource}`, { headers: authHeaders() });
  return data;
}
export async function adminCreate(resource, body) {
  const { data } = await api.post(`/admin/${resource}`, body, { headers: authHeaders() });
  return data;
}
export async function adminUpdate(resource, id, body) {
  const { data } = await api.put(`/admin/${resource}/${id}`, body, { headers: authHeaders() });
  return data;
}
export async function adminDelete(resource, id) {
  const { data } = await api.delete(`/admin/${resource}/${id}`, { headers: authHeaders() });
  return data;
}

// Upload
export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/admin/upload`, fd, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
  });
  const base = process.env.REACT_APP_BACKEND_URL;
  return { ...data, absolute_url: `${base}${data.public_url}` };
}

// Same endpoint accepts PDFs and images alike (post storage_service MIME_TYPES update)
export const uploadFile = uploadImage;
